import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classname';

const propTypes = {
	left: PropTypes.string,
	top: PropTypes.string,
	isActive: PropTypes.bool
};

class Timezone extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		const style = { left: this.props.left, top: this.props.top };
		return (
			<span className={cn('timezone-item', this.props.isActive && 'timezone-item--active')}  style={style}/>
		);
	}
}

Timezone.propTypes = propTypes;
export default Timezone;



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/profile/components/timezones-map/timezone.js